import { baseUrl } from '../../network'

export const getBillFiltersUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/bills/filters`
export const getBillsUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/bills`
export const getBillsOverviewUrl = (companyId: number) => baseUrl + `api/company/${companyId}/bills/overview`
export const getBillUrl = (billId: number) => baseUrl + `api/bills/${billId}`
export const updateBillUrl = (billId: number) => baseUrl + `api/bills/${billId}`